import { useMantineTheme } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import {
  Notifications,
  NotificationsProps as NotificationsProviderProps,
} from '@mantine/notifications';

import classes from './Notification.module.css';

const NotificationsDefaults = Notifications.extend({
  classNames: {
    root: classes.notifications_root,
  },
});

const NotificationProvider = (props: NotificationsProviderProps) => {
  const theme = useMantineTheme();
  const isSmallScreen = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`, true, {
    getInitialValueInEffect: false,
  });
  const defaultProps = theme.components.Notifications.defaultProps as NotificationsProviderProps;

  return (
    <Notifications
      position={defaultProps?.position ?? (isSmallScreen ? 'top-center' : 'bottom-right')}
      {...props}
    />
  );
};

export { NotificationProvider, NotificationsDefaults };
